import { auth, db, FirebaseTimestamp } from "../../firebase";
import { push } from 'connected-react-router';

const questionsRef = db.collection('questions')

export const saveQuestion = (id,userID,subject,question,organizerID) => {
    return async (dispatch) => {
        return auth.onAuthStateChanged(user => {
            if (user) {
                const timestamp = FirebaseTimestamp.now();

                const data = {
                    boothID: id,
                    questionerID: userID,
                    subject: subject,
                    question: question,
                    organizerID: organizerID,
                    created_at: timestamp
                }
                return questionsRef.add(data)
                .then(() => {
                    
                    dispatch(push("/boothlist/" + id))
                }).catch((error) => {
                    // console.dir("エラー後のdataは" + JSON.stringify(data));
                    console.log("エラー後のidは" + id);
                    throw new Error(error)
                })

            } else {
                dispatch(push('/signin'))
            }
        })
    }
}


// export const saveQuestion = (id,userID,subject,question,organizerID) => {
//     return async (dispatch) => {
        
//         const timestamp = FirebaseTimestamp.now();
//         const data = {
//             boothID: id,
//             questionerID: userID,
//             subject: subject,
//             question: question,
//             organizerID: organizerID,
//             created_at: timestamp
//         }
//         // console.dir("id作成した後のdataは" + JSON.stringify(data));
//         return questionsRef.add(data)
//             .then(() => {
                
//                 dispatch(push("/boothlist/" + id))
//             }).catch((error) => {
//                 // console.dir("エラー後のdataは" + JSON.stringify(data));
//                 console.log("エラー後のidは" + id);
//                 throw new Error(error)
//             })
//     }
// }